export const environment = {
  production: true,
  BASE_BACKEND_URL: 'https://staging-backend.crazycall.com',
  CALL_PANEL_URL: 'https://staging-call.crazycall.com',
  SSO_URL: 'https://staging-sso.crazycall.com',
  WEB_WIDGET_URL: 'https://make-a-call-with-qa13.aws-app.be',
  IFRAME_ADDRESS: 'https://crazy-website-widget.crazycall.com/',
  CRAZYCALL_BACKEND_URL: 'https://staging-backend.crazycall.com',
  SENTRY_ENABLED: false,
  APP_ID: 'crazycall-staging-dev',
  INTERNATIONALIZATION_URL: 'https://s3-eu-west-1.amazonaws.com/crazycall-staging-internationalization/web-frontend/',
  COOKIE_DOMAIN: '.crazycall.com',
  TYPEFORM_URL: 'https://andrzejmuzaj.typeform.com/to/bnST41',
  LEAD_GENERATION_ENV: 'staging',
  CHANNELS_URL: 'https://staging-app.aws-app.be',
  BACKEND_CHANNELS_URL: 'https://staging-backend.aws-app.be',
  SHOPER_CONNECT_URL: 'http://localhost:3000',
  PIPEDRIVE_INTEGRATION_URL: 'https://marketplace.pipedrive.com/app/channels-app/15f3a9f9bf009218',
  SHOPIFY_INTEGRATION_URL: 'https://apps.shopify.com/channels',
  LIVECHAT_INTEGRATION_URL: 'https://my.livechatinc.com/settings/marketplace/private',
  MAGENTO_INTEGRATION_URL: 'https://marketplace.magento.com/channels-module-channels.html',
  AMPLITUDE_API_KEY: '7bcc2d43e8e7bbbec39ff5977ce94bc9',
  ZENDESK_INTEGRATION_URL: 'https://www.zendesk.com/apps/support/channels/',
  HUBSPOT_INTEGRATION_PATH: '/integrations/platform-callback/hubspot',
  SHOPER_INTEGRATION_URL: 'https://www.shoper.pl/aplikacje/channels/',
  ZAPIER_INTEGRATION_URL: 'https://zapier.com/apps/channels/integrations',
  CANNOT_USE_APP_URL: 'https://res.channels.app/cannot-use-app',
  DEFAULT_HOW_TO_LINK: 'https://support.channels.app',
  ZENDESK_HOW_TO_LINK: 'https://support.channels.app/articles/360016583759-Channels-Zendesk-integration-tutorial',
  HUBSPOT_HOW_TO_LINK: 'https://support.channels.app/articles/360016268440-Channels-HubSpot-integration-tutorial',
  SHOPER_HOW_TO_LINK: 'https://support.channels.app/sections/360004109660-Integracja-z-Shoper',
  SHOPIFY_HOW_TO_LINK: 'https://support.channels.app/sections/360003779140-Integrating-Channels-with-Shopify',
  PIPEDRIVE_HOW_TO_LINK: 'https://support.channels.app/sections/360003819159-Integrating-Channels-with-Pipedrive',
  LIVECHAT_HOW_TO_LINK: 'https://support.channels.app/sections/360003882519-LiveChat-integration',
  MAGENTO_HOW_TO_LINK: 'https://support.channels.app/articles/360017363380-Channels-service-connector',
  CHROME_STORE_WIDGET_ID: 'bhilbngoghjcnmhhpgihpdcbnfgecnhj',
  TWO_WAY_INTEGRATION_URL: 'https://my-test.2way.app/channels/login',
  INTEGROMAT_INTEGRATION_URL: 'https://www.integromat.com/en/integrations/channels',
  CLIENTIFY_INTEGRATION_URL: 'https://clientify.net/settings/connect/',
  CLIENTIFY_HOW_TO_LINK: 'https://www.youtube.com/watch?v=F9sXl1AYDQQ ',
};
